<template>
  <layout-basic>
      <v-container v-if="!isPartnerLevel">
        <v-row>
          <v-col class="Full-Course-Library-Title">
            My password
          </v-col>
        </v-row>
        <v-row class="mt-5">
          <v-col md="6">
            <v-form>
              <v-text-field
                :error-messages="messages.old_password"
                v-model="user.old_password"
                label="Current Password"
                type="password"
                class="pass-input-width"
                filled
              ></v-text-field>
              <v-text-field
                :error-messages="messages.new_password"
                v-model="user.new_password"
                label="New Password"
                type="password"
                class="pass-new-input-width"
                filled
              >
                <template slot="append-outer">
                  <v-tooltip right>
                   <template v-slot:activator="{on}">
                    <v-icon v-on="on">fa fa-question</v-icon>
                   </template>
                   <span>The New Password must be at least 8 characters, contain 1 uppercase, 1 lowercase & 1 special Charecter.</span>
                  </v-tooltip>
                </template>
              </v-text-field>
              <v-text-field
                :error-messages="messages.confirm_password"
                v-model="user.confirm_password"
                label="Confirm New Password"
                type="password"
                filled
                class="pass-new-input-width"
              >
              <template slot="append-outer">
                <v-tooltip left>
                  <template v-slot:activator="{on}">
                    <v-icon v-on="on">fa fa-question</v-icon>
                  </template>
                  <span>The Confirm New Password must be same as password.</span>
                </v-tooltip>
              </template>
              </v-text-field>
            </v-form>
          </v-col>
        </v-row>
        <v-row>
          <v-col md="3" class="updatePasswordBtn">
            <v-btn
              class="btn btn-primary add-course-button text-right"
              color="primary"
              @click.prevent="updatePassword"
              outlined
            >Update Password</v-btn>
          </v-col>
        </v-row>
      </v-container>
      <profile-layout v-if="isPartnerLevel">
        <v-container>
          <v-row>
          <v-col md="4" offset-md="4">
            <v-form>
              <v-text-field
                :error-messages="messages.old_password"
                v-model="user.old_password"
                label="Current Password"
                type="password"
              ></v-text-field>
              <v-text-field
                :error-messages="messages.new_password"
                v-model="user.new_password"
                label="New Password"
                type="password"
              ></v-text-field>
              <v-text-field
                :error-messages="messages.confirm_password"
                v-model="user.confirm_password"
                label="Confirm New Password"
                type="password"
              ></v-text-field>
            </v-form>
          </v-col>
        </v-row>
        <v-row>
          <v-col md="4" offset-md="4">
            <v-btn v-if="loading" color="white" loading></v-btn>
            <v-btn v-else
              class="btn btn-primary add-course-button"
              color="white"
              @click.prevent="updatePassword"
              outlined
            >Update Password</v-btn>
          </v-col>
        </v-row>
        </v-container>
      </profile-layout>
  </layout-basic>
</template>
<script>
import LayoutBasic from "@/layouts/Dashboard";
import ProfileLayout from "@/layouts/Profile";
import userAPI from "@/api/user.js";

export default {
  name: "Profile",
  components: {
    LayoutBasic,
    ProfileLayout
  },
  data() {
    return {
      user: {},
      messages: {},
      loading: false,
      successMessage: "Password Successfully Updated.",
      errorMessage:
        "Oops, something went wrong! Please check information is correct."
    };
  },
  computed : {
    isPartnerLevel: function () {
      if (this.$store.getters.level == 4) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    updatePassword() {
      this.loading = true;
      userAPI
        .updatePassword(this.user)
        .then(() => {
          this.$snotify.success(this.successMessage);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
          this.$store.dispatch("logout").then(() => {
            this.$router.push("/login");
          });
        })
        .catch(err => {
          this.$snotify.error(this.errorMessage);
          this.messages = this.$gf.errorResponse(err);
          this.loading = false;
        });
    }
  }
};
</script>
<style scoped>
.updatePasswordBtn {
  justify-content: end;
  display: flex;
  margin-left: 20px;
}

@media (min-width: 768px) and (max-width: 1024px) {
  .updatePasswordBtn {
    justify-content: center;
    display: flex;
    margin-left: 0 !important;
  }
}

@media (min-width: 820px) and (max-width: 1180px) {
  .updatePasswordBtn {
    justify-content: center;
    display: flex;
    margin-left: 0 !important;
  }
}
</style>